/*
 * @Description: 中英文 label 宽
 * @Author: kanglin
 * @Date: 2018-06-08 14:31:25
 * @Copyright: Created by Panxsoft.
 */
export default {
	methods: {
		labelWidth(chinese_width = 80, english_width = 140) {
			return chinese_width;
		},
	},
};

